import React, {Component} from 'react';
import {withStyles} from "@material-ui/core";
import XLSX from 'xlsx';
import axios from 'axios';
import _ from 'lodash';

const vspacing = 20;

class ExcelViewer extends Component {
    constructor(props) {
        super(props);

        this.iFrame = React.createRef();
        this.pageBefore = null;

        this.state = {
            pageNumber: this.props.pageNumber,
            sheets: [],
            width: this.props.width,
            height: this.props.height,
        };

        axios.get(this.props.filename, {responseType: 'arraybuffer'}).then((response) => {
            var wb = XLSX.read(response.data, { type: 'array' });
            let sheets = [];
            _.each(wb.Sheets, (sheet) => {
                sheets.push(XLSX.utils.sheet_to_html(sheet));
            });
            this.setState({sheets});
        });

        if ( this.props.doResize ) {
            this.props.doResize( (width, height) => {
                this.setState({width, height});
            } )
        }
    }

    componentDidMount() {
        this._updateIframe();
    }

    componentDidUpdate() {
        this._updateIframe();
    }


    _updateIframe() {
        const document = this.iFrame.current.contentDocument;
        if (this.pageBefore !== this.state.pageNumber && this.state.sheets && this.state.sheets.length > this.state.pageNumber - 1) {
            this.pageBefore = this.state.pageNumber;
            document.body.innerHTML = '';
            document.write(this.state.sheets[this.state.pageNumber - 1]);
        }
        this.iFrame.current.width = this.state.width;
        this.iFrame.current.height = this.state.height;
    }

    render() {
        return (
            <React.Fragment>
                <iframe ref={this.iFrame} />
            </React.Fragment>
        );
    }
}


const styles = theme => ({});


export default withStyles(styles)(ExcelViewer);



// WEBPACK FOOTER //
// ./resources/assets/js/components/File/ExcelViewer.jsx